import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { ProductListService } from '@b2b/features/product/core/services/product-list.service';
import { FacetsAppliedComponent } from '@b2b/components/facets/facets-applied/facets-applied.component';
import { FacetsToApplyComponent } from '@b2b/components/facets/facets-to-apply/facets-to-apply.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';
@Component({
  selector: 'facets',
  imports: [CommonModule, FacetsAppliedComponent, FacetsToApplyComponent, TranslateModule, LocalLoaderComponent],
  templateUrl: './facets.component.html',
  styleUrl: './facets.component.scss',
})
export class FacetsComponent implements OnInit {
  facets$ = this.productListService.get().pipe(
    map(productList => {
      return {
        facetGroups: productList.facetGroups,
        appliedFacets: productList.appliedFacets,
      };
    }),
  );

  constructor(private productListService: ProductListService) {}

  ngOnInit(): void {
    this.productListService.setFacetsApplied([]);
  }
}
